var key = {};
if (process.env.NODE_ENV == "production") {
  key = {
    frontUrl: "https://waiqdemo-2025.pages.dev",
    baseUrl: "https://waiqdemo.wearedev.team/api",
    txLink: "https://testnet.bscscan.com/",
    rpcUrl: "https://bsc-testnet-rpc.publicnode.com",
    network: 97,
    chaincode: "bsc",
    contractAddress: "0x99f1Ef9216Cfc3e5Af75929E2da128C6263e767A",
    usdtContract: "0x9336E83E6Bb110899b40bC10B74E2E9fECF7922D",
    priceProvider: "0x2514895c72f50D8bd4B4F9b1110F0D6bD2c97526",
  }
} else {
  key = {
    frontUrl: "http://localhost:3000",
    baseUrl: "http://localhost:2025/api",
    txLink: "https://testnet.bscscan.com/",
    rpcUrl: "https://bsc-testnet-rpc.publicnode.com",
    network: 97,
    chaincode: "bsc",
    contractAddress: "0x99f1Ef9216Cfc3e5Af75929E2da128C6263e767A",
    usdtContract: "0x9336E83E6Bb110899b40bC10B74E2E9fECF7922D",
    priceProvider: "0x2514895c72f50D8bd4B4F9b1110F0D6bD2c97526",
    txurl: "https://testnet.bscscan.com",
  };
}
export default key;
